import React from "react";
import "./spinner.css";

const Spinner = ({customStyles}) => <div className="loader" style={{...customStyles}}/>;
export default Spinner;
